import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try { setUser(await api.me()); } catch { setUser(false); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const signIn = (data) => { localStorage.setItem(TOKEN_KEY, data.token); setUser(data.user); };
  const signOut = () => { localStorage.removeItem(TOKEN_KEY); setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, refresh, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isActive = (u) => u && (u.role === "admin" || ["trialing", "active"].includes(u.subscription_status));

export function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm text-[color:var(--bcs-text-mut)]" data-testid="auth-loading">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
